"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockBackgroundMusicToJSON = exports.StockBackgroundMusicFromJSONTyped = exports.StockBackgroundMusicFromJSON = exports.instanceOfStockBackgroundMusic = void 0;
var runtime_1 = require("../runtime");
var AudioType_1 = require("./AudioType");
var Status_1 = require("./Status");
/**
 * Check if a given object implements the StockBackgroundMusic interface.
 */
function instanceOfStockBackgroundMusic(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStockBackgroundMusic = instanceOfStockBackgroundMusic;
function StockBackgroundMusicFromJSON(json) {
    return StockBackgroundMusicFromJSONTyped(json, false);
}
exports.StockBackgroundMusicFromJSON = StockBackgroundMusicFromJSON;
function StockBackgroundMusicFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'assetType': !(0, runtime_1.exists)(json, 'asset_type') ? undefined : json['asset_type'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, Status_1.StatusFromJSON)(json['status']),
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'audioType': !(0, runtime_1.exists)(json, 'audio_type') ? undefined : (0, AudioType_1.AudioTypeFromJSON)(json['audio_type']),
        'collections': !(0, runtime_1.exists)(json, 'collections') ? undefined : json['collections'],
        'genre': !(0, runtime_1.exists)(json, 'genre') ? undefined : json['genre'],
        'genres': !(0, runtime_1.exists)(json, 'genres') ? undefined : json['genres'],
        'moods': !(0, runtime_1.exists)(json, 'moods') ? undefined : json['moods'],
        'artists': !(0, runtime_1.exists)(json, 'artists') ? undefined : json['artists'],
        'coverArtUrl': !(0, runtime_1.exists)(json, 'cover_art_url') ? undefined : json['cover_art_url'],
        'recommendedStartTime': !(0, runtime_1.exists)(json, 'recommended_start_time') ? undefined : json['recommended_start_time'],
    };
}
exports.StockBackgroundMusicFromJSONTyped = StockBackgroundMusicFromJSONTyped;
function StockBackgroundMusicToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'asset_type': value.assetType,
        'status': (0, Status_1.StatusToJSON)(value.status),
        'url': value.url,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'audio_type': (0, AudioType_1.AudioTypeToJSON)(value.audioType),
        'collections': value.collections,
        'genre': value.genre,
        'genres': value.genres,
        'moods': value.moods,
        'artists': value.artists,
        'cover_art_url': value.coverArtUrl,
        'recommended_start_time': value.recommendedStartTime,
    };
}
exports.StockBackgroundMusicToJSON = StockBackgroundMusicToJSON;
